module.exports = __webpack_public_path__ + "static/img/ycaddress.d97b39d5.png";